<template>
  <div class="common_detail_bg_container flex flex-row px-1 py-[3px] gap-[2px]">
    <ThemeImage :icon="imageNames.LOCK_GREY" alt="private_icon" class="size-[11px]" />
    <span class="text-[11px]">Private</span>
  </div>
</template>

<script setup>
import {imageNames} from "@/src/constants/imageConstants.js";
</script>
